(ns minorodata.components.warehouse-usage.core
  (:require
   [minorodata.app.handlers :refer [dispatch]]
   [minorodata.components.home-dashboard.toolbar :as toolbar]
   [minorodata.components.warehouse-usage.account-usage :as account-usage]
   [minorodata.components.warehouse-usage.summary :as summary]
   [re-posh.core :as re-posh]
   [ui.page :as page]
   [ui.tabs :as tabs]))

(def ^:private valid-tabs #{"summary" "account-usage"})
(def ^:private default-tab "summary")

(defn- page-content []
  (let [query         @(re-posh/subscribe [:app-route/prop :app-route/query])
        effective-tab (if (contains? valid-tabs (:tab query)) (:tab query) default-tab)]
    [:div
     {:class "container mx-auto flex flex-col px-6 py-8"}
     [tabs/tabs-root {:value           effective-tab
                      :on-value-change #(dispatch [:app.events/navigate-query {:tab %}])}
      [:div {:class "flex items-stretch justify-between gap-4 border-b border-kleene-layout-border"}
       [tabs/tabs-list {:variant :underlined
                        :class   "border-b-0 self-end"}
        [tabs/tabs-trigger {:value "summary" :variant :underlined} "Summary"]
        [tabs/tabs-trigger {:value "account-usage" :variant :underlined} "Account usage"]]

       [:div {:class "flex items-center gap-2 pb-2 shrink-0"}
        (if (= effective-tab "account-usage")
          [:<>
           [toolbar/refresh-button {:on-refresh account-usage/refresh!}]
           [account-usage/date-selector]]
          [:<>
           [toolbar/refresh-button {:on-refresh summary/refresh!}]
           [summary/date-selector]])]]

      [tabs/tabs-content {:value "summary"} [summary/usage-tab]]
      [tabs/tabs-content {:value "account-usage"} [account-usage/usage-tab]]]]))

(defn page []
  [page/page-root
   [page/page-header
    [page/page-title "Warehouse usage"]]
   [page/page-content {:class "p-0"}
    [page-content]]])
